import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=af10776a&"
import script from "./Checkbox.vue?vue&type=script&lang=js&"
export * from "./Checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af10776a')) {
      api.createRecord('af10776a', component.options)
    } else {
      api.reload('af10776a', component.options)
    }
    module.hot.accept("./Checkbox.vue?vue&type=template&id=af10776a&", function () {
      api.rerender('af10776a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/lib/vue/components/modules/Checkbox.vue"
export default component.exports